<template>
	<div class='container' @click='inputActive=-1'>
	<img class="bg" :src="bg_pic">
	<header class="header">
		<img class='logo-icon' :src='config.logo'/>
		<span class="title">{{config.systemName}}</span>
		<span class="slogan">{{config.slogan}}</span>
	</header>
		<div class="login">
			<div class="title">系统登录</div>
			<div class="input">
				<div :class="['input-item',inputActive==1?'input-active':'']"
				 @click.stop='inputFoucs(1)'>
					<i class="iconfont icon-user"></i>
					<input placeholder="用户名/手机号" ref='1' v-model='loginInfo.username'
					 @keyup.enter="login" @keyup.tab='inputFoucs(1)' maxlength="50" />
				</div>
				<!-- <div :class="['input-item',inputActive==2?'input-active':'']"
				 @click.stop='inputFoucs(2)'>
					<i class="iconfont icon-password"></i>
					<input type='password' placeholder="密码" ref='2' v-model='loginInfo.password'
					 @keyup.enter="login" @keyup.tab='inputFoucs(2)' maxlength="50" />
				</div> -->
				<div :class="['input-item',inputActive==3?'input-active':'']"
				 @click.stop='inputFoucs(3)'>
					<i class="iconfont icon-verification-code-copy"></i>
					<input placeholder="验证码" ref='3' v-model='loginInfo.code'
					 @keyup.enter="login" @keyup.tab='inputFoucs(3)' maxlength="4" />
					<el-button type="primary" size="mini" :disabled="codeTime > 0"
					 @click="sendCode" class="code-btn">
						<span v-show="codeTime <= 0">获取验证码</span>
						<span v-show="codeTime > 0">{{codeTime}}s</span>
					</el-button>
				</div>
				<!-- <img class="code" @click='changeCode'
				 :src="captcha+'/'+random"> -->
			</div>
			<div class="login-btn" @click='login'>登录</div>
		</div>
	</div>
</template>

<script scoped>
import common from '@/api/common'
import { config } from '../layout/config/config'
import { captcha, login, sendSms } from '@/api/login/index'
import bg_pic from '@/assets/img/background.png'
export default {
	name: "login",
	data() {
	return {
		config: config,
		bg_pic: bg_pic,
		// input高亮
		inputActive: -1,
		// 验证码随机数
		random: Math.round((Math.random()*10000)),
		// 登录信息
		loginInfo: {
			username: "",
			password: "",
			code: ""
		},
		codeTime: 0,
		// 静态接口
		captcha: captcha
	};
	},
	mounted() {
		this.inputFoucs(1)
	},
	methods: {
	inputFoucs(index) {
		this.inputActive = index;
		this.$refs[index].focus();
	},
	changeCode() {
		this.random = Math.round((Math.random()*10000));
	},

	// 发送验证码
	sendCode() {
		if (this.loginInfo.username) {
			let data = {
				phone: this.loginInfo.username
			}
			sendSms(data).then((res) => {
				if (res.Success) {
					this.countdown()
					this.$message.success("验证码发送成功！");
				} else {
					this.$message.error(res.Msg);
				}
			}).catch(res => {
				console.log(res)
				this.$message.error("验证码发送失败！");
			})
		} else {
			this.$message.error("请输入账号！");
		}
	},

	// 倒计时
	countdown() {
		this.codeTime = 60
		let timer = setInterval(() => {
			this.codeTime--;
			if(this.codeTime < 0){
				clearInterval(timer)
			}
		}, 1000)
	},

	// 登录
	login() {
		if (this.loginInfo.username
		 &&this.loginInfo.code) {
			/*登录*/
			let data = {
				loginAccount: this.loginInfo.username,
				authCode: this.loginInfo.code,
				type: "SMS"
			}
			login(data).then((res) => {
				console.log(res,'res');
				if(res.Success){
				/*记录用户信息*/
				this.$store
					.dispatch("user/login", {
						id: res.Data.userInfo.userId,
						name: res.Data.userInfo.userName,
						token: res.Data.tokenInfo.tokenValue,
						tokenName: res.Data.tokenInfo.tokenName
					})
					.then(res => {
						common.commonUrl.headers[res.tokenName] = res.token//（设置方法非最佳，仅临时解决token问题）
						this.$router.push({ path: "/home" });
					})
					.catch(res => {
					console.log(res)
					this.$message.error("出错啦！");
					});
				}else{
				this.changeCode();
				this.$message.error(res.Msg)
				}
			}).catch(res => {
				console.log(res)
				this.$message.error('登录失败！')
			})
		
		} else {
			this.$message.error("登录信息不完整！");
		}
	}
	}
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
	@background_color_1: #1a2f4e;
	@background_color_2: #1c3150;
	.bg{
		position: absolute;
		width: 100%;
		height: 100%;
		min-height: 100vh;
	}
	.container {
		position: relative;
		background-size: 100% 100%;
		width: 100%;
		min-height: 665px;
		height: 100vh;
		.header {
			position: relative;
			display: flex;
			align-items: center;
			width: 100%;
			height: 80px;
			background-color: #fff;
			.logo-icon {
			margin-left: 50px;
			width: 30px;
			height: 26px;
			}
			.title{
				margin-left: 13px;
				font-size: 26px;
				font-weight: bold;
				color: #2C2B40;
			}
			.slogan{
				position: absolute;
				right: 30px;
				font-size: 18px;
				color: #465974;
			}
		}
	}
	.login {
		position: absolute;
		top: 50%;
		left: 50%;
		border-radius: 6px;
		transform: translateX(-50%) translateY(-55%);
		background: #fff;
		padding: 27px 36px;
		.title {
			text-align: center;
			font-size: 26px;
			color: #2c2b40;
			margin-bottom: 48px;
			font-weight: bold;
		}
		@backcolor_btn: #31c6da;
		.login-btn {
			cursor: pointer;
			width: 320px;
			height: 50px;
			line-height: 50px;
			background: @backcolor_btn;
			font-size: 20px;
			color: #fff;
			text-align: center;
			margin-top: 36px;
			margin-bottom: 17px;
			border-radius: 4px;
			&:hover {
			background: @backcolor_btn - 10;
			}
		}
		.input {
			overflow: hidden;
		}
		.input-item {
			position: relative;
			display: flex;
			overflow: hidden;
			width: 320px;
			box-sizing: border-box;
			padding: 12px;
			border: 1px solid #f2f2f2;
			border-radius: 4px;
			margin-bottom: 14px;
			.iconfont{
				font-size: 18px;
			}
			input {
				box-sizing: border-box;
				flex: 1;
				width: 0;
				height: 24px;
				border: none;
				outline: none;
				color: #2c2b40;
				font-size: 16px;
				&::-webkit-input-placeholder {
					/* WebKit browsers */
					color: #a8b1c5;
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: #a8b1c5;
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: #a8b1c5;
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10+ */
					color: #a8b1c5;
				}
			}
			i {
			margin-right: 12px;
			height: 24px;
			line-height: 24px;
			color: #a8b1c5;
			}
		}
		.input-active {
			border: 1px solid #2b77ef;
		}
		.input-item-code {
			width: 172px;
			float: left;
		}
		.code {
			float: right;
			cursor: pointer;
			box-sizing: border-box;
			border: 1px solid #eee;
			border-radius: 4px;
			width: 100px;
			height: 50px;
		}
		.code-btn{
			min-width: 96px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue